export default "__VITE_ASSET__CV727v5o__"